module.exports = __webpack_public_path__ + "img/empty-state-box.8b4da8ac.svg";